// extracted by mini-css-extract-plugin
module.exports =  {"controls":"a10a3f92e9--controls--Gk6nl","controls--hidden":"a10a3f92e9--controls--hidden--NUkI9","single":"a10a3f92e9--single--Ua2jW"};